import style from "./style.module.scss";

export const MonthTick = ({ x, y, payload, angle }) => {
  // const [month, year] = payload.value.split("/");
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        className={style.month}
        textAnchor={angle ? "end" : "middle"}
        dy={12}
        transform={angle ? `rotate(${angle})` : undefined}
      >
        {payload?.value}
      </text>
      {/* <text className={style.year} textAnchor="middle" dy={22}>
        {year}
      </text> */}
    </g>
  );
};
